// src/services/operationalScenariosService.js
import { api } from '../api/apiClient';

// REMOVED: 14 dead methods — OperationalScenario model CRUD + CTI generation utilities, never called by any component
// Removed: getOperationalScenarios, getOperationalScenariosByAttackPath, createOperationalScenario,
// updateOperationalScenario, deleteOperationalScenario, generateOperationalScenariosAI,
// bulkCreateOperationalScenarios, exportOperationalScenarios, getOperationalScenarioStats,
// generateScenariosFromCTI, buildEBIOSPrompt, parseAIResponse, validatePhases, createFallbackScenario

/**
 * Save CTI-generated scenarios with React Flow state to database
 * @param {string} analysisId - Analysis ID
 * @param {Array} scenarios - Generated scenarios
 * @param {Object} reactFlowState - React Flow nodes and edges state
 * @returns {Promise<Object>} Save result
 */
export const saveCTIScenarios = async (analysisId, scenarios, reactFlowState = null) => {
  try {
    const payload = {
      scenarios,
      reactFlowState,
      generatedAt: new Date().toISOString(),
      source: 'CTI-AI-Generated'
    };

    const endpoint = `/analyses/${analysisId}/cti-operational-scenarios`;
    const response = await api.post(endpoint, payload);

    if (response && response.data) {
      const responseData = response.data;
      if (responseData.componentId && responseData.savedAt && typeof responseData.scenariosCount === 'number' && !responseData.success) {
        return {
          success: true,
          message: `CTI operational scenarios saved successfully (${responseData.scenariosCount} scenarios)`,
          data: responseData
        };
      }
      return responseData;
    } else {
      return { success: false, message: 'No response received' };
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Load CTI-generated scenarios with React Flow state from database
 * @param {string} analysisId - Analysis ID
 * @returns {Promise<Object>} Saved scenarios with React Flow state
 */
export const loadCTIScenarios = async (analysisId) => {
  try {
    const response = await api.get(`/analyses/${analysisId}/cti-operational-scenarios`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return {
        success: true,
        data: {
          scenarios: [],
          reactFlowState: null,
          lastSaved: null
        }
      };
    }
    throw error;
  }
};

/**
 * Delete a specific CTI operational scenario
 * @param {string} analysisId - Analysis ID
 * @param {string} scenarioId - Scenario ID to delete
 * @returns {Promise<Object>} Delete response
 */
export const deleteCTIScenario = async (analysisId, scenarioId) => {
  try {
    const response = await api.delete(`/analyses/${analysisId}/cti-operational-scenarios/${encodeURIComponent(scenarioId)}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};